export default "__VITE_ASSET__Y7BGws95__"